const SmoothiesData = [
  {
    productname: "PSO SPECIAL",
    productdescription:
      "A signature soya-based smoothie enriched with nuts and fruits",
  },
  {
    productname: "OREO CHOCOLATE",
    productdescription: "Oreo chocolate drink with cream and cocoa",
  },
  {
    productname: "PRANIC POWER",
    productdescription:
      "Detox juice rich in vitamin, fiber and antioxidants that promote your health",
  },
  {
    productname: "FRESH FRUIT (Seasonal)",
    productdescription: "Juice made from fresh seasonal fruits",
  },
];
export default SmoothiesData;
